export default [
  {
    path: "/events",
    name: "events",
    component: () => import("@/views/pages/events/Events.vue"),
    meta: {
      hasPermission:true,
      pageTitle: "رویداد ها",
      breadcrumb: [
        {
          text: "رویداد ها",
          active: true,
        },
      ],
    },
  },
  {
    path: "/events/add",
    name: "add-event",
    component: () => import("@/views/pages/events/event-form/EventForm.vue"),
    meta: {
      hasPermission:true,
      pageTitle: "اضافه کردن رویداد",
      breadcrumb: [
        {
          text: "رویداد ها",
          to: "/events",
        },
        {
          text: "اضافه کردن رویداد",
          active: true,
        },
      ],
    },
  },
  {
      path: "/events/:id/edit",
      name: "edit-event",
      component: () => import("@/views/pages/events/event-form/EventForm.vue"),
      meta: {
        hasPermission:true,
        pageTitle: "ویرایش کردن رویداد",
        breadcrumb: [
          {
            text: "رویداد ها",
            to: "/events",
          },
          {
            text: "ویرایش کردن رویداد ",
            active: true,
          },
        ],
      },
    },
];

